import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { useSlackLinkCompletion } from '@/hooks/use-slack-link-completion.hook';
import { BRAND } from '@/lib/brand';

export function SlackLinkConsent() {
  const link = useSlackLinkCompletion();
  return (
    <AlertDialog open={link.open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Link your Slack account to Clu?</AlertDialogTitle>
          <AlertDialogDescription>
            Only continue if both accounts below are yours. Clu will use this{' '}
            {BRAND.name} account and its organization access when you message
            from Slack.
          </AlertDialogDescription>
        </AlertDialogHeader>
        {link.preview && (
          <div className='space-y-2 text-sm'>
            <p>
              {BRAND.name}: {link.cleanlistName} ({link.organizationName})
            </p>
            <p>Slack workspace: {link.preview.teamName}</p>
            <p>
              Slack account:{' '}
              <a
                className='underline'
                href={`slack://user?team=${encodeURIComponent(link.preview.teamId)}&id=${encodeURIComponent(link.preview.slackUserId)}`}
              >
                {link.preview.slackUserId} (open profile to verify)
              </a>
            </p>
          </div>
        )}
        {link.busy && <p role='status'>Checking your accounts...</p>}
        {link.error && <p role='alert'>{link.error}</p>}
        <AlertDialogFooter>
          <AlertDialogCancel disabled={link.busy} onClick={link.cancel}>
            Cancel
          </AlertDialogCancel>
          {link.canRetry && (
            <Button variant='outline' disabled={link.busy} onClick={link.retry}>
              Retry
            </Button>
          )}
          <AlertDialogAction
            disabled={link.busy || !link.preview || !!link.error}
            onClick={(event) => {
              event.preventDefault();
              void link.confirm();
            }}
          >
            Yes, these are my accounts
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
